import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import type { Employee } from '@/types/chat';

interface ChatHeaderProps {
  user: Employee | null;
  isOnline: boolean;
}

export function ChatHeader({ user, isOnline }: ChatHeaderProps) {
  if (!user) return null;

  return (
    <div className="p-4 border-b flex items-center gap-3">
      <div className="relative">
        <Avatar>
          <AvatarImage src={user.empAvatar || ''} />
          <AvatarFallback>{user.empName.charAt(0)}</AvatarFallback>
        </Avatar>
        <span
          className={`absolute bottom-0 right-0 h-3 w-3 rounded-full border-2 border-white ${
            isOnline ? 'bg-green-500' : 'bg-gray-300'
          }`}
        />
      </div>
      <div>
        <h2 className="font-semibold">{user.empName}</h2>
        <p className="text-[10px] text-green-500">
          {isOnline ? 'Online' : 'Offline'}
        </p>
      </div>
    </div>
  );
}
